import { gql } from "@apollo/client";

export const SearchAssetClusters = gql`
    query SearchAssetClusters(
        $bounds: GeoBoundingBoxInput!
        $filter: SearchAssetFilter
    ) {
        searchAssetClusters(boundingBox: $bounds, filter: $filter) {
            assetCount
            total
            clusters {
                totalCount
                singleLocation
                center {
                    lat
                    lng
                }
                boundingBox {
                    northeast {
                        lat
                        lng
                    }
                    southwest {
                        lat
                        lng
                    }
                }
                assetStatusCounts {
                    status
                    count
                }
            }
        }
    }
`;
